export default {
  textColor: '#473F51',
  lightColor: '#BCBCBC',
  baseColor: '#FE605E',
  baseColorDarker: '#E75856',
  fontLight: 'Sailec-Light, sans-serif',
  fontRegular: 'Sailec-Regular, sans-serif',
  fontMedium: 'Sailec-Medium, sans-serif'
};



// WEBPACK FOOTER //
// ./src/pages/Landing/theme.js